// extracted by mini-css-extract-plugin
module.exports = {"content":"Layout_content__126Oe","content_no_user":"Layout_content_no_user__27yv2"};